import { useInfiniteQuery } from '@tanstack/react-query';
import { getTransactions } from 'Services/transactions';
import { useErrors } from 'Components/Organisms/ErrorsProvider';
import { RESULTS_PER_PAGE } from 'Utils/constants';

export default function useInfiniteTransactions(filters, options = {}) {
    const { showUnknownError } = useErrors();

    return useInfiniteQuery(
        ['transactions', filters],
        async ({ pageParam = 1 }) => {
            const response = await getTransactions({
                ...filters,
                page: pageParam,
            });

            return response;
        },
        {
            ...options,
            refetchOnWindowFocus: false,
            onError: (err) => showUnknownError(err),
            getNextPageParam: (lastPage, allPages) => {
                const pagesLoaded = allPages.length;
                const totalPages = Math.ceil(lastPage.count / RESULTS_PER_PAGE);
                return pagesLoaded < totalPages ? pagesLoaded + 1 : false;
            },
        },
    );
}
